import React, { Component } from 'react';
import { translate } from 'react-i18next';
import TimesItem from './TimesItem';

const weekDays = [
  { key: 'mon', tKey: 'geozones:mo' },
  { key: 'tue', tKey: 'geozones:tu' },
  { key: 'wed', tKey: 'geozones:we' },
  { key: 'thu', tKey: 'geozones:th' },
  { key: 'fri', tKey: 'geozones:fr' },
  { key: 'sat', tKey: 'geozones:sa' },
  { key: 'sun', tKey: 'geozones:su' },
];

class TimesList extends Component {
  render() {

    return (
      <div className="times_list">
        {weekDays.map((day, index) => (
          <TimesItem
            first={index === 0}
            key={day.key}
            day={day.key}
            title={this.props.t(day.tKey)}
            value={this.props[day.key]}
            changeDayHandler={this.props.changeDayHandler}
            changeTimeHandler={this.props.changeTimeHandler}
          />
        ))}
      </div>
    );
  }
}

TimesList.propTypes = {};
TimesList.defaultProps = {};

export default translate(['geozones'], { wait: false })(TimesList);



// WEBPACK FOOTER //
// ./src/components/Modal/GeozonesModal/Times/TimesList.js